import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["href", "onClick"]
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { class: "font-bold" }

import Icons from '@/components/subcomponents/Icons.vue'
import { INavBarItem } from '@/models/navbar'
import { useLanguageStore } from '@/stores/LanguageStore'
import { TieredMenu } from 'primevue'
import { onUnmounted, ref } from 'vue'

const HIDE_DELAY = 200

export default /*@__PURE__*/_defineComponent({
  __name: 'NavBarRailGroup',
  props: {
    item: {}
  },
  setup(__props: any) {

const OPEN_CLASSES = ['bg-[var(--p-primary-100)]', 'dark:bg-[var(--p-primary-800)]']

let closeOpenedFlyout: (() => void) | null = null



const languageStore = useLanguageStore()

const flyout = ref<InstanceType<typeof TieredMenu> | null>(null)
const trigger = ref<HTMLButtonElement | null>(null)

let hideTimer: ReturnType<typeof setTimeout> | undefined

const setOpenState = (open: boolean) => {
  const element = trigger.value

  if (!element) {
    return
  }

  element.setAttribute('aria-expanded', String(open))
  OPEN_CLASSES.forEach((openClass) => element.classList.toggle(openClass, open))
}

const hideFlyout = () => {
  flyout.value?.hide()
  if (closeOpenedFlyout === hideFlyout) {
    closeOpenedFlyout = null
  }
}

const cancelHide = () => {
  clearTimeout(hideTimer)
  hideTimer = undefined
}

const scheduleHide = () => {
  cancelHide()
  hideTimer = setTimeout(hideFlyout, HIDE_DELAY)
}

const enableSubmenuHover = () => {
  const menu = flyout.value as unknown as { dirty?: boolean } | null

  if (menu) {
    menu.dirty = true
  }
}

const openFlyout = (event: Event) => {
  cancelHide()

  if (closeOpenedFlyout && closeOpenedFlyout !== hideFlyout) {
    closeOpenedFlyout()
  }

  closeOpenedFlyout = hideFlyout
  flyout.value?.show(event)
  enableSubmenuHover()
}

onUnmounted(() => {
  cancelHide()
  if (closeOpenedFlyout === hideFlyout) {
    closeOpenedFlyout = null
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("button", {
      ref_key: "trigger",
      ref: trigger,
      type: "button",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-label": _unref(languageStore).t(__props.item.label),
      class: "flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-md transition-colors hover:bg-surface-100 dark:hover:bg-surface-800",
      onMouseenter: openFlyout,
      onMouseleave: scheduleHide,
      onClick: openFlyout,
      onKeydown: _withKeys(hideFlyout, ["esc"])
    }, [
      _createVNode(Icons, {
        icon: __props.item.icon,
        class: "shrink-0 font-bold"
      }, null, 8, ["icon"])
    ], 40, _hoisted_1)), [
      [
        _directive_tooltip,
        _unref(languageStore).t(__props.item.label),
        void 0,
        { top: true }
      ]
    ]),
    _createVNode(_unref(TieredMenu), {
      ref_key: "flyout",
      ref: flyout,
      model: __props.item.items,
      popup: "",
      pt: { root: { onMouseenter: cancelHide, onMouseleave: scheduleHide } },
      onShow: _cache[0] || (_cache[0] = ($event: any) => (setOpenState(true))),
      onHide: _cache[1] || (_cache[1] = ($event: any) => (setOpenState(false)))
    }, {
      item: _withCtx(({ item: entry, props, hasSubmenu }) => [
        (entry.to)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: entry.to,
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _createElementVNode("a", _mergeProps({ href: href }, props.action, {
                  class: "flex items-center gap-2",
                  onClick: navigate
                }), [
                  _createVNode(Icons, {
                    icon: entry.icon,
                    class: "shrink-0 font-bold"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(languageStore).t(entry.label as string)), 1)
                ], 16, _hoisted_2)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (_openBlock(), _createElementBlock("a", _mergeProps({ key: 1 }, props.action, { class: "flex items-center justify-between gap-2" }), [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(Icons, {
                  icon: entry.icon,
                  class: "shrink-0 font-bold"
                }, null, 8, ["icon"]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(languageStore).t(entry.label as string)), 1)
              ]),
              hasSubmenu
                ? (_openBlock(), _createBlock(Icons, {
                    key: 0,
                    icon: "chevron-right",
                    class: "shrink-0 font-bold"
                  }))
                : _createCommentVNode("", true)
            ], 16))
      ]),
      _: 1
    }, 8, ["model", "pt"])
  ], 64))
}
}

})